import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$enablePayLater',
  initialState,
  reducers: {
    setEnablePayLater(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnablePayLater } = slice.actions;
export default slice.reducer;
